var map = {
	"./Category/index.vue": [
		"6c3a",
		"view-Category-index-vue"
	],
	"./Item/create.vue": [
		"a8b6",
		"view-Item-create-vue"
	],
	"./Item/edit.vue": [
		"db70",
		"view-Item-edit-vue"
	],
	"./Item/index.vue": [
		"654a",
		"view-Item-index-vue"
	],
	"./Purchase/create.vue": [
		"b1eb",
		"view-Purchase-create-vue"
	],
	"./Purchase/index.vue": [
		"c91e",
		"view-Purchase-index-vue"
	],
	"./Purchase/index1.vue": [
		"b678",
		"view-Purchase-index1-vue"
	],
	"./Purchase/return-report.vue": [
		"e583",
		"view-Purchase-return-report-vue"
	],
	"./Purchase/return.vue": [
		"abd9",
		"view-Purchase-return-vue"
	],
	"./Sales/create.vue": [
		"4382",
		"view-Sales-create-vue"
	],
	"./Sales/index.vue": [
		"a6b2",
		"view-Sales-index-vue"
	],
	"./Sales/return-report.vue": [
		"124a",
		"view-Sales-return-report-vue"
	],
	"./Sales/return.vue": [
		"eb8c",
		"view-Sales-return-vue"
	],
	"./Unit/index.vue": [
		"89ef",
		"view-Unit-index-vue"
	],
	"./Warehouse/index.vue": [
		"db7f",
		"view-Warehouse-index-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3368";
module.exports = webpackAsyncContext;